var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "leak-investigation-reports-table overflow-auto" },
    [
      _vm.leakInvestigationReports.length > 0
        ? _c(
            "div",
            { staticStyle: { "min-width": "800px" } },
            [
              _c(
                "b-row",
                {
                  staticClass: "my-3 px-3 pt-1 fixed table-row",
                  attrs: { "no-gutters": "" },
                },
                _vm._l(_setup.fields, function (field) {
                  return _c(
                    "b-col",
                    {
                      key: field.key,
                      class: [
                        "d-flex col align-items-center mr-3",
                        field.sortable ? "cursor-pointer" : "",
                        field.key === "actions"
                          ? "justify-content-center mr-0"
                          : "",
                      ],
                      on: {
                        click: function ($event) {
                          field.sortable
                            ? _setup.handleHeaderClick(field.key)
                            : null
                        },
                      },
                    },
                    [
                      _vm._v("\n        " + _vm._s(field.label) + "\n        "),
                      field.sortable
                        ? _c(
                            "span",
                            {
                              staticClass: "ml-3 d-flex flex-column sort-icons",
                            },
                            [
                              _c("i", {
                                staticClass: "fa fa-sort-up",
                                class: {
                                  "text-secondary":
                                    _vm.sortBy !== field.key || !_vm.sortDesc,
                                },
                              }),
                              _vm._v(" "),
                              _c("i", {
                                staticClass: "fa fa-sort-down",
                                class: {
                                  "text-secondary":
                                    _vm.sortBy !== field.key || _vm.sortDesc,
                                },
                              }),
                            ]
                          )
                        : _vm._e(),
                    ]
                  )
                }),
                1
              ),
              _vm._v(" "),
              _vm._l(_vm.leakInvestigationReports, function (report) {
                return _c(
                  "b-card",
                  {
                    key: report.workOrderGuid,
                    staticClass: "report-card font-weight-bold rounded-xl",
                    attrs: { "no-body": "" },
                    on: {
                      click: function ($event) {
                        return _setup.handleDownload(report.workOrderGuid)
                      },
                    },
                  },
                  [
                    _c(
                      "b-card-body",
                      { staticClass: "cursor-pointer" },
                      [
                        _c(
                          "b-row",
                          {
                            staticClass: "table-row",
                            attrs: { "no-gutters": "", "align-v": "center" },
                          },
                          [
                            _c(
                              "b-col",
                              { staticClass: "d-flex align-items-center" },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(report.leakbotId) +
                                    "\n          "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              {
                                staticClass:
                                  "d-flex align-items-center table-col",
                              },
                              [
                                report.partnerReference
                                  ? _c(
                                      "span",
                                      { staticClass: "text-truncate" },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(report.partnerReference) +
                                            "\n            "
                                        ),
                                      ]
                                    )
                                  : _c(
                                      "span",
                                      {
                                        staticClass:
                                          "text-secondary text-truncate",
                                      },
                                      [_vm._v("-")]
                                    ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { staticClass: "d-flex align-items-center" },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(report.workOrderNumber) +
                                    "\n          "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { staticClass: "d-flex align-items-center" },
                              [
                                report.pdfLastModifiedAt
                                  ? _c(
                                      "div",
                                      { staticClass: "d-flex flex-column" },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _setup.formatDate(
                                                report.pdfLastModifiedAt
                                              )
                                            )
                                          ),
                                        ]),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { staticClass: "d-flex align-items-center" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "d-flex flex-column" },
                                  [
                                    report.leakCategories?.length > 0
                                      ? _c(
                                          "div",
                                          { staticClass: "d-flex flex-column" },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(report.leakCategories[0])
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            report.leakCategories?.length > 1
                                              ? _c(
                                                  "small",
                                                  {
                                                    staticClass:
                                                      "text-sm cursor-pointer",
                                                    attrs: {
                                                      title:
                                                        report.leakCategories
                                                          .slice(1)
                                                          .join("\r\n"),
                                                      role: "button",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          `+${
                                                            report
                                                              .leakCategories
                                                              .length - 1
                                                          } more`
                                                        ) +
                                                        "\n                "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        )
                                      : _c("div", [
                                          _vm._v(
                                            "\n                Unknown\n              "
                                          ),
                                        ]),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { staticClass: "d-flex justify-content-center" },
                              [
                                _c(
                                  "b-button",
                                  {
                                    staticClass:
                                      "text-center text-body d-flex align-items-center rounded-pill p-3",
                                    attrs: {
                                      disabled: _setup.isDownloading(
                                        report.workOrderGuid
                                      ),
                                      variant: "outline-light",
                                      title: "Download latest report",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _setup.handleDownload(
                                          report.workOrderGuid
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _setup.isDownloading(report.workOrderGuid)
                                      ? _c("div", {
                                          staticClass:
                                            "spinner-border spinner-border-sm",
                                          attrs: { role: "status" },
                                        })
                                      : _setup.isDownloaded(
                                          report.workOrderGuid
                                        )
                                      ? _c("i", {
                                          staticClass: "fa fa-check fa-lg",
                                        })
                                      : _c("i", {
                                          staticClass: "fa fa-download fa-lg",
                                        }),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
            ],
            2
          )
        : _c("b-card", { staticClass: "text-center" }, [
            _c("i", { staticClass: "fa fa-info-circle fa-2x text-muted mb-2" }),
            _vm._v(" "),
            _c("p", { staticClass: "text-muted mb-0" }, [
              _vm._v(
                "\n      No Claims Mitigation Reports found matching your search criteria.\n    "
              ),
            ]),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }